var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"vue-tree"},[_c('ul',[_c('b-tree-item',{attrs:{"node":item,"code":item.code || '_'}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }